<template>

    <div class="must-have-exactly-one-root-element">

        <main class="dashboardBackground grey">

            <kravicka-paralax
                :kravicka="kravicka"
            />

            <img v-if="kravicka.kravicka_pozadie" :src="'assets/img/' + paralaxMobile" alt="" class="dashboadMobileBackground">

            <!--<kravicka-animacia-video-->
                    <!--ref="kravickaAnimacieVideo"-->
            <!--&gt;-->
            <!--</kravicka-animacia-video>-->

            <!--<kravicka-animacia-gif-->
                <!--ref="kravickaAnimacieGif"-->
            <!--&gt;-->
            <!--</kravicka-animacia-gif>-->


            <kravicka-animacia-apng
                    ref="kravickaAnimacieApng"
                    @showBubble="showBubble"
                    @hideBubble="hideBubble"
                    @animationEnded="animationEnded"
            >
            </kravicka-animacia-apng>

            <div v-if="hlaska != ''" class="o-bubble">
                <div class="m-bubble__content">
                    <div class="a-bubble__text">{{ hlaska }}</div>
                </div>
                <button @click="hlaska = ''" class="m-bubble__close">
                    <span class="icon"></span>
                </button>
            </div>
        </main>

        <!-- Aside -->
        <aside class="dashboardControls w-100 h-100">

            <!-- Header -->
            <header-kravicka
                @updateProfil="emitUpdateProfil"
                @hideBottomControls="hideBottomControls"
                :profil="profil"
                :show.sync="show"
            />

            <!-- Main 2 -->
            <div class="dashboradControlsBottom fixed-bottom" :style="'z-index:' + stastomerZindex">
                <div class="rowitems d-flex align-items-end justify-content-between">

                    <!-- Bottom left -->
                    <div class="dashboardControlsBottom__left">

                        <!-- Šťasťomer -->
                        <div class="o-stastomer d-none d-md-block">
                            <div :class="'stastomerWrap' + statsDetailOpen">

                                <!-- Hlava -->
                                <div class="m-stastomerImg">
                                    <div class="a-stastomerBgCircle"></div>
                                    <img
                                        v-if="kravicka.kravicka_img_hlava"
                                        :src="'https://www.adoptujkravicku.sk/data/foto/' + kravicka.kravicka_img_hlava"
                                        alt=""
                                    >
                                </div>

                                <!-- HP + button -->
                                <div class="m-stastomerZdravie">
                                    <!-- HP details button -->
                                    <a class="a-stastomerZdravie__button" @click="statsMenu()">
                                        <span class="icon"></span>
                                    </a>
                                    <span class="a-stastomerZdravie__hodnota">{{ param_global }}%</span>
                                </div>

                                <!-- Info button -->
                                <div class="m-stastomerInfo">
                                    <a class="a-stastomerInfo__button" @click="$bvModal.show('modalInfo')">
                                        <span class="icon"></span>
                                    </a>
                                </div>
                            </div>

                            <!-- HP details -->
                            <div :class="'m-stastomerDetail' + statsOpen">
                                <!-- Meno -->
                                <div class="a-stastomerDetail__name">
                                    <p>{{ kravicka.kravicka_meno }}</p>
                                </div>

                                <div class="a-stastomerDetail__progressbars">
                                    <!-- Jedlo -->
                                    <div class="progressBarBody">
                                        <span class="progressBarTitle">Jedlo</span>
                                        <span class="progressBar">
                                            <span class="progressBarValue progressFood" :style="{ width: kravicka.kravicka_param_jedlo + '%' }"></span>
                                        </span>
                                    </div>

                                    <!-- Pitie -->
                                    <div class="progressBarBody">
                                        <span class="progressBarTitle">Pitie</span>
                                        <span class="progressBar">
                                            <span class="progressBarValue progressDrink" :style="{ width: kravicka.kravicka_param_pitie + '%' }"></span>
                                        </span>
                                    </div>

                                    <!-- Zábava -->
                                    <div class="progressBarBody">
                                        <span class="progressBarTitle">Zábava</span>
                                        <span class="progressBar">
                                            <span class="progressBarValue progressFun" :style="{ width: kravicka.kravicka_param_zabava + '%' }"></span>
                                        </span>
                                    </div>

                                    <!-- Čistota -->
                                    <div class="progressBarBody">
                                        <span class="progressBarTitle">Čistota</span>
                                        <span class="progressBar">
                                            <span class="progressBarValue progressCleanness" :style="{ width: kravicka.kravicka_param_cistota + '%' }"></span>
                                        </span>
                                    </div>
                                </div>

                                <!-- Close button -->
                                <div class="a-stastomer__close" @click="statsMenu()">
                                    <span class="icon"></span>
                                </div>
                            </div>
                            <!-- .HP details -->
                        </div>
                        <!-- .Šťasťomer -->


                        <!-- Šťasťomer phone -->
                        <div :class="'o-stastomer --mobile d-md-none ' + statsOpen">

                            <!-- Hlava + HP + button -->
                            <div class="m-stastomer__button--mobile">
                                <div class="a-stastomerBgCircle"></div>
                                <img :src="'https://www.adoptujkravicku.sk/data/foto/' + kravicka.kravicka_img_hlava" alt="" @click="statsMenu()">
                                <span class="a-stastomerZdravie__hodnota">{{ param_global }}%</span>
                            </div>

                            <!-- HP details -->
                            <div class="stastomerWrap">
                                <!-- Hlava -->
                                <div class="m-stastomerImg">
                                    <div class="a-stastomerBgCircle"></div>
                                    <img :src="'https://www.adoptujkravicku.sk/data/foto/' + kravicka.kravicka_img_hlava" alt="" @click="statsMenu()">
                                </div>

                                <!-- HP + button -->
                                <div class="m-stastomerZdravie">
                                    <a class="a-stastomerZdravie__button"><span class="icon"></span></a>
                                    <!-- HP details button -->
                                    <span class="a-stastomerZdravie__hodnota">{{ param_global }}%</span>
                                </div>

                                <!-- Info button -->
                                <div class="m-stastomerInfo">
                                    <a class="a-stastomerInfo__button"><span class="icon" data-toggle="modal" data-target="#modalInfo"></span></a>
                                </div>
                            </div>

                            <!-- HP details phone -->
                            <div class="m-stastomerDetail">
                                <!-- Meno -->
                                <div class="a-stastomerDetail__name">
                                    <p>{{ kravicka.kravicka_meno }}</p>
                                </div>

                                <div class="a-stastomerDetail__progressbars">
                                    <!-- Jedlo -->
                                    <div class="progressBarBody">
                                        <span class="progressBarTitle">Jedlo</span>
                                        <span class="progressBar">
                                            <span class="progressBarValue progressFood" :style="{ width: kravicka.kravicka_param_jedlo + '%' }"></span>
                                        </span>
                                    </div>

                                    <!-- Pitie -->
                                    <div class="progressBarBody">
                                        <span class="progressBarTitle">Pitie</span>
                                        <span class="progressBar">
                                            <span class="progressBarValue progressDrink" :style="{ width: kravicka.kravicka_param_pitie + '%' }"></span>
                                        </span>
                                    </div>

                                    <!-- Zábava -->
                                    <div class="progressBarBody">
                                        <span class="progressBarTitle">Zábava</span>
                                        <span class="progressBar">
                                            <span class="progressBarValue progressFun" :style="{ width: kravicka.kravicka_param_zabava + '%' }"></span>
                                        </span>
                                    </div>

                                    <!-- Čistota -->
                                    <div class="progressBarBody">
                                        <span class="progressBarTitle">Čistota</span>
                                        <span class="progressBar">
                                            <span class="progressBarValue progressCleanness" :style="{ width: kravicka.kravicka_param_cistota + '%' }"></span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <!-- .HP details phone -->

                            <div class="a-stastomer__overlay"></div>
                            <!-- Close button -->
                            <div class="a-stastomerMobile__button--close"  @click="statsMenu()">
                                <span class="icon"></span>
                            </div>
                        </div>
                        <!-- .Šťasťomer phone -->

                    </div>
                    <!-- .Bottom left -->

                    <!-- Bottom right -->
                    <div class="dashboardControlsBottom__right">
                        <!-- Store -->
                        <div class="o-itemsButtons">
                            <div :class="'m-itemsButtons__additional' + rightMenuOpen">
                                
                                <b-button class="a-itemButton" v-b-tooltip.hover.left title="Obchod" @click="$router.push({ name: 'obchod', params: { kategoria: 'food', kravicka_id: kravicka.id } }); rightMenu()">
                                    <span class="icon --cart"></span>
                                </b-button>
                                <b-button class="a-itemButton" v-b-tooltip.hover.left title="Pozadie"  @click="inventarMenu('background', 'Pozadie'); rightMenu()">
                                    <span class="icon --image"></span>
                                </b-button>
                                <b-button class="a-itemButton" v-b-tooltip.hover.left title="Šatník" @click="$router.push({ name: 'satnik', params: { kategoria: 'satnik', kravicka_id: kravicka.id } }); rightMenu()">
                                    <span class="icon --shirt"></span>
                                </b-button>
                                <b-button class="a-itemButton" v-b-tooltip.hover.left title="Jedlo" @click="inventarMenu('food', 'Jedlo'); rightMenu()">
                                    <span class="icon --food"></span>
                                </b-button>
                                <b-button class="a-itemButton" v-b-tooltip.hover.left title="Pitie" @click="inventarMenu('drink', 'Pitie'); rightMenu()">
                                    <span class="icon --drink"></span>
                                </b-button>
                                <b-button class="a-itemButton" v-b-tooltip.hover.left title="Čistota" @click="inventarMenu('cleanness', 'Čistota'); rightMenu()">
                                    <span class="icon --clean"></span>
                                </b-button>
                                <b-button class="a-itemButton" v-b-tooltip.hover.left title="Minihry" @click="inventarMenu('games', 'Minihry'); rightMenu()">
                                    <span class="icon --games"></span>
                                </b-button>
                            </div>
                            <div class="m-itemsButtons_main" @click="rightMenu()">
                                <img class="img-fluid" src="assets/img/cowIcon.svg" alt="Cow Icon">
                            </div>
                        </div>
                        <!-- .Store -->
                    </div>
                    <!-- .Bottom right -->
                </div>

                <inventar-kravicka
                    :menuOpen="menuOpen"
                    :menuOpenKategoria="menuOpenKategoria"
                    :menuOpenNazov="menuOpenNazov"
                    :kravicka="kravicka"
                    @hideInventar="hideInventarMenu"
                    @useInventarProdukt="useInventoryProduct"
                />

            </div>
            <!-- .Main 2 -->
        </aside>



        <!-- Modal -->
        <b-modal id="modalInfo" hide-footer hide-header centered tabindex="-1" role="dialog" aria-labelledby="modalInfoTitle" aria-hidden="true" ref="modalInfo">
                    <!-- Close -->
            <b-button class="m-modalInfo__close" block @click="$bvModal.hide('modalInfo')"><span class="icon"></span></b-button>

            <!-- Info -->
            <div class="modal-body o-modalInfo">
                <h2 class="m-modalInfo__name text-center">{{ kravicka.kravicka_meno }}</h2>
                <div class="m-modalInfo_imageWrap">
                    <div class="a-modalInfo__bgCircle">
                        <!--<img src="assets/img/modalCowHead.png" alt="">-->
                        <img :src="'https://www.adoptujkravicku.sk/data/foto/' + kravicka.kravicka_img_hlava" alt="">
                    </div>
                    <div class="a-modalInfoZdravie">
                        <a class="modalInfoZdravie__button"><span class="icon"></span></a>
                        <span class="modalInfoZdravie__hodnota">{{ param_global }}%</span>
                    </div>
                    <div class="a-facebookShare">
                        <a href="https://www.facebook.com/AdoptujKravicku/" class="btn --facebook"><span class="icon"></span></a>
                    </div>
                </div>

                <div v-if="kravicka.ean_kravicky" class="m-modalInfo__cowData">
                    <table>
                        <tr>
                            <td>Počet zadaných EAN kódov</td>
                            <td class="value">{{ kravicka.ean_kravicky.length }}</td>
                        </tr>
                        <tr>
                            <td>Moje číslo</td>
                            <td class="value">{{ kravicka.kravicka_regcislo }}</td>
                        </tr>
                        <tr>
                            <td>Bývam na farme</td>
                            <td class="value">{{ kravicka.dvor_id.dvor_nazov }}</td>
                        </tr>
                        <tr>
                            <td>Dátum narodenia</td>
                            <td class="value">{{ kravicka.kravicka_datum_nar | moment('D.M.YYYY') }}</td>
                        </tr>
                        <!--<tr>-->
                            <!--<td>Odkaz na zdieľanie kravičky</td>-->
                            <!--<td class="value">-->
                                <!--<a href="www.adoptujkravicku.sk/123456">www.adoptujkravicku.sk/123456</a>-->
                            <!--</td>-->
                        <!--</tr>-->
                    </table>
                </div>

                <div class="m-modalInfo__footer d-flex">
                    <div class="a-modalInfo__misc">
                        <!--TODO migracia URL-->
                        <a href="http://adoptujkravicku.sk/kravicky/" class="adoptCow">
                            <span class="icon"></span>Adoptovať ďalšiu kravičku
                        </a>
                        <router-link :to="{ name: 'uprava-kravicky', params: { kravicka_id: kravicka.id, kravicka_meno: kravicka.kravicka_meno, kravicka_meno_rodica: kravicka.kravicka_meno_rodica } }" class="editData">
                            <span class="icon"></span>Upraviť údaje
                        </router-link>
                    </div>

                    <div class="a-modalInfo__btn">
                        <a :href="'https://adoptujkravicku.sk/hra/kravicka/rodny-list/' + kravicka.id" class="btn --primary">
                            <span class="icon-certificate"></span>Rodný list
                        </a>
                    </div>
                </div>

            </div>
            <!-- .Info -->
        </b-modal>
        <!-- .Modal -->

    </div>
</template>



<script>
    import EventService     from '@/services/EventService.js'
    import HeaderKravicka   from '../partials/HeaderKravicka.vue'
    import InventarKravicka from '../partials/InventarKravicka.vue'
    // import KravickaAnimaciaVideo from "../partials/KravickaAnimaciaVideo.vue"
    // import KravickaAnimaciaGif from "../partials/KravickaAnimaciaGif.vue"
    import KravickaAnimaciaApng from "../partials/KravickaAnimaciaApng.vue"
    import KravickaParalax from "../partials/KravickaParalax.vue"

    export default {
        components: {
            HeaderKravicka,
            InventarKravicka,
            // KravickaAnimaciaVideo,
            // KravickaAnimaciaGif,
            KravickaAnimaciaApng,
            KravickaParalax
        },
        props: [
            'profil',
            'kravicka',
            'error'
        ],
        mounted() {
            this.getKravickaData()
        },
        data() {
            return {
                show: '',

                statsOpen: '',
                statsDetailOpen: '',
                stastomerZindex: 1,

                rightMenuOpen: '',

                menuOpen: false,
                menuOpenKategoria: '',
                menuOpenNazov: '',

                param_global: '',
                paralaxMobile: '',
                animacie: '',
                hlaska: '',

                isDisabled: [false, false, false],
                preloaderImg: 'preloader.png', //'icon_repa.svg',
                produktImg: '',
                produktIndex: '',

                responseType: '',
                responseText: '',

                achievementProgress: [],
                enumKombo: '',
                enumUspechy: ''
            }
        },
        methods: {
            // emit
            emitUpdateProfil() {
                this.$emit('updateProfil')
            },


            // mounted
            getKravickaData() {
                if (typeof(this.kravicka.id) == 'undefined' || this.$route.params.kravicka_id != this.kravicka.id) {
                    this.$emit('update:kravicka', {})
                    this.$emit('update:satnik', {})
                    EventService.getKravickaData(this.$route.params.kravicka_id)
                        .then(response => {
                            //console.log(response.data)
                            this.param_global  = Number((response.data.data[0].kravicka_param_global).toFixed(0))
                            this.paralaxMobile = response.data.data[0].kravicka_pozadie.herny_produkt_img_inventar.replace("paralax", "dashboard").replace("Obchod.jpg", "BgXs.jpg")
                            this.$emit('update:kravicka', response.data.data[0])
                        })
                        .catch(error => {
                            this.responseType = 'warning'
                            this.responseText = error
                        })

                } else {
                    // param_zabava + param_global
                    for (var i = 0; i < this.profil.pouzivatel_id.kravicky_pouzivatela.length; i++) {
                        if (this.profil.pouzivatel_id.kravicky_pouzivatela[i].id == this.kravicka.id) {
                            this.kravicka.kravicka_param_zabava = this.profil.pouzivatel_id.kravicky_pouzivatela[i].kravicka_param_zabava
                            this.kravicka.kravicka_param_global = this.profil.pouzivatel_id.kravicky_pouzivatela[i].kravicka_param_global
                        }
                    }

                    // console.log(this.kravicka)
                    this.param_global  = Number((this.kravicka.kravicka_param_global).toFixed(0))
                    this.paralaxMobile = this.kravicka.kravicka_pozadie.herny_produkt_img_inventar.replace("paralax", "dashboard").replace("Obchod.jpg", "BgXs.jpg")
                }
            },

            // click
            statsMenu() {
                this.statsOpen == ' open' ?  this.statsOpen = '' : this.statsOpen = ' open'
                this.statsDetailOpen == ' detail-open' ?  this.statsDetailOpen = '' : this.statsDetailOpen = ' detail-open'
                this.statsOpen == ' open' ?  this.stastomerZindex = 10 : this.stastomerZindex = 1
            },

            toggleBodyClass(addRemoveClass, className) {
                const el = document.body
                if (addRemoveClass === 'addClass') {
                    el.classList.add(className)
                } else {
                    el.classList.remove(className)
                }
            },

            hideBottomControls() {
                //console.log('hideBottomControls')
                this.hideInventarMenu()
                this.rightMenuOpen = ''
            },

            rightMenu() {
                this.show = ''
                if ( this.rightMenuOpen === ' open' ) {
                    this.rightMenuOpen = ''
                }
                else {
                    this.hideInventarMenu()
                    this.rightMenuOpen = ' open'
                }
            },


            inventarMenu(kategoria, nazov) {
                this.menuOpen = true
                this.menuOpenKategoria = kategoria
                this.menuOpenNazov = nazov
            },

            hideInventarMenu() {
                this.menuOpen = false
                this.menuOpenKategoria = ''
                this.menuOpenNazov = ''
            },


            // inventar
            useInventoryProduct(index, item) {
                //console.log(this.isDisabled)
                if (!this.isDisabled[0] && !this.isDisabled[1] && !this.isDisabled[2]) {
                    if (parseInt(item.repozitar_kravicky_usage_type) < 1) {
                        this.hlaska = 'Tento produkt sa mi už minul'
                        this.isDisabled = false
                        this.$router.push({ name: 'obchod', params: { kategoria: item.repozitar_kravicky_category, kravicka_id: this.kravicka.id } })

                    } else {
                        this.isDisabled = [true, true, true]
                        var text = ''
                        var zvuk = ''
                        if (item.herny_produkt_id.herny_produkt_hlasky != null) {
                            var randText = item.herny_produkt_id.herny_produkt_hlasky.replace("[\"", "").replace("\"]", "").replace("\",\"", ";").split(";")
                            var randZvuk = item.herny_produkt_id.herny_produkt_zvuk.replace('["', '').replace('"]', '').replace('","', ';').split(";")
                            var rand = Math.floor(Math.random() * Math.floor(text.length))
                            text = randText[rand]
                            zvuk = randZvuk[rand]
                        }

                        // preloader animácie start
                        if (item.repozitar_kravicky_category != "background") {
                            console.log('show preloader: ' + index)
                            this.produktIndex = index
                            // nahradí ikonu
                            /*this.produktImg = this.kravicka.repozitar_kravicky[index].herny_produkt_id.herny_produkt_img_inventar
                            this.kravicka.repozitar_kravicky[index].herny_produkt_id.herny_produkt_img_inventar = this.preloaderImg*/
                            // pridá preloader ikonu
                            this.produktImg = this.kravicka.repozitar_kravicky[index].herny_produkt_id.herny_produkt_povoleny
                            this.kravicka.repozitar_kravicky[index].herny_produkt_id.herny_produkt_povoleny = this.preloaderImg
                            this.$emit('update:kravicka', this.kravicka)
                        }

                        // ajax call
                        this.useProduct(index, item, text, zvuk)
                    }
                }
            },

            useProduct(index, item, hlaska, zvuk) {
                let repo_id    = item.id
                let category   = item.repozitar_kravicky_category
                let usage_type = item.repozitar_kravicky_usage_type
                let produkt_id = item.herny_produkt_id.id
                let percenta   = item.herny_produkt_id.herny_produkt_percenta
                let animacia   = item.herny_produkt_id.herny_produkty_animacie_id
                let zvuk_animacia = item.herny_produkt_id.herny_produkt_zvuk_animacia

                EventService.useProduct(
                    this.profil.pouzivatel_id.id,
                    this.kravicka.id,
                    produkt_id,
                    repo_id,
                    usage_type,
                    this.kravicka.kravicka_param_jedlo,
                    this.kravicka.kravicka_param_pitie,
                    this.kravicka.kravicka_param_zabava,
                    this.kravicka.kravicka_param_cistota,
                    this.kravicka.kravicka_param_state,
                    item.herny_produkt_id.herny_produkt_img_inventar
                )
                    .then(response => {
                        //console.log(response.data)
                        this.responseType = response.data.code
                        this.responseText = response.data.data

                        if (response.data.code == 'success') {
                            // zobraz bublinku a prehraj zvukovú nahrávku
                            // if (hlaska != '') {
                            //     this.hlaska = 'Farmár práve pripravuje ' + category + ' pre tvoju kravičku'
                            //     this.hlaska = hlaska
                            //     this.playSound('assets/audio/bubble/' + zvuk + '.wav')
                            // }

                            if (category != "background") {
                                this.$refs.kravickaAnimacieApng.startActionAnimation(animacia, category + '/' + zvuk_animacia, zvuk, hlaska)

                                var check = parseFloat(percenta)
                                if (category == "food") {
                                	// alert('spustí sa animácia ako kravička papá (jedlo s id:' + produkt_id + ')')

                                    // this.playSound('assets/audio/jedlo.wav')

                                    check += parseFloat(this.kravicka.kravicka_param_jedlo)
                                    if (check > 100) {
                                        this.kravicka.kravicka_param_jedlo = 100
                                    } else {
                                        this.kravicka.kravicka_param_jedlo += parseFloat(percenta)
                                    }

                            	} else if (category == "drink") {
                                	// alert('spustí sa animácia ako kravička pije (nápoj s id:' + produkt_id + ')')
                                    // this.$refs.kravickaAnimacieApng.playActionAnimation(animacia)
                                    // this.playSound('assets/audio/pitie.wav')

                                    check += parseFloat(this.kravicka.kravicka_param_pitie)
                                    if (check > 100) {
                                        this.kravicka.kravicka_param_pitie = 100
                                    } else {
                                        this.kravicka.kravicka_param_pitie += parseFloat(percenta)
                                    }

                            	} else if (category == "cleanness") {
                                	//alert('spustí sa animácia čistenia kravičky (čistiaci prostriedok s id:' + produkt_id + ')')
                                    // this.$refs.kravickaLoopAnimacie.initActionVideo(animacia)

                                    check += parseFloat(this.kravicka.kravicka_param_cistota)
                                    if (check > 100) {
                                        this.kravicka.kravicka_param_cistota = 100
                                    } else {
                                        this.kravicka.kravicka_param_cistota += parseFloat(percenta)
                                    }
                        		}

                        		//this.kravicka.kravicka_param_global += parseFloat(percenta) / 4
                                this.kravicka.kravicka_param_global = (parseFloat(this.kravicka.kravicka_param_jedlo) + parseFloat(this.kravicka.kravicka_param_pitie) + parseFloat(this.kravicka.kravicka_param_cistota) + parseFloat(this.kravicka.kravicka_param_zabava)) / 4

                                this.param_global = Number((this.kravicka.kravicka_param_global).toFixed(0))
                                if (usage_type != "999") {
                                    this.kravicka.repozitar_kravicky[index].repozitar_kravicky_usage_type -= 1
                                }
                                this.$emit('update:kravicka', this.kravicka)

                                for (var i = 0; i < this.profil.pouzivatel_id.kravicky_pouzivatela.length; i++) {
                                    if (this.profil.pouzivatel_id.kravicky_pouzivatela[i].id == this.kravicka.id) {
                                        this.profil.pouzivatel_id.kravicky_pouzivatela[i].kravicka_param_global = this.kravicka.kravicka_param_global
                                    }
                                }
                                this.$emit('update:profil', this.profil)

                            } else {
                                this.kravicka.kravicka_pozadie = item.herny_produkt_id
                                this.paralaxMobile = item.herny_produkt_id.herny_produkt_img_inventar.replace("paralax", "dashboard").replace("Obchod.jpg", "BgXs.jpg")
                                this.$emit('update:kravicka', this.kravicka)

                                for (var i = 0; i < this.profil.pouzivatel_id.kravicky_pouzivatela.length; i++) {
                                    if (this.profil.pouzivatel_id.kravicky_pouzivatela[i].id === this.kravicka.id) {
                                        this.profil.pouzivatel_id.kravicky_pouzivatela[i].kravicka_pozadie_profil = item.herny_produkt_id.herny_produkt_img_inventar
                                    }
                                }
                                this.$emit('update:profil', this.profil)
                                this.isDisabled[2] = false // pozadie nemá animáciu
                            }

                        // achievements
                        this.prepAchievements(produkt_id)

                        } else {
                        	this.hlaska = this.responseText
                            this.isDisabled[0] = false
                        }
                    })
                    .catch(error => {
                        this.responseType = 'warning'
                        this.responseText = error
                    })
            },

            // preloader animácie end
            animationEnded() {
                //console.log('animationEnded(): ' + this.produktIndex)
                if (this.produktIndex !== '') {
                    console.log('hide preloader: ' + this.produktIndex)
                    // vráti pôvodnú ikonu
                    //this.kravicka.repozitar_kravicky[this.produktIndex].herny_produkt_id.herny_produkt_img_inventar = this.produktImg
                    // vráti pôvodnú hodnotu a schová preloader ikonu
                    this.kravicka.repozitar_kravicky[this.produktIndex].herny_produkt_id.herny_produkt_povoleny = this.produktImg
                    this.$emit('update:kravicka', this.kravicka)
                }
                this.isDisabled[2] = false
            },

            showBubble(textBublinky) {
                if ( textBublinky !== '' ) {
                    this.hlaska = textBublinky
                    setTimeout(function(){ this.hideBubble() }.bind(this), 3000)
                }
            },

            hideBubble() {
                this.hlaska = ''
            },


            // achievements
            prepAchievements(produkt_id) {
                // achievements ids
                if (this.achievementProgress.length == 0) {
                    // kombá - jedlo (32, 36)
                    var a = {'83':0, '95':0, '116':0}   // brokolica, kiwi, špargľa
                    var b = {'97':0, '89':0, '86':0}    // koláč, džem, čokoláda
                    // kombá - pitie (25)
                    var c = {'122':0, '123':0, '3':0}   // čaj, voda, koktejl
                    // kombá - čistenie (2, 6, 34)
                    var d = {'27':0, '135':0, '10':0}   // šampón, fén, kefa
                    var e = {'147':0, '156':0, '150':0} // mydlo, uterák, parfém
                    var f = {'145':0, '151':0, '146':0} // makeup, rúž, maskara
                    // vytvor "session"
                    this.achievementProgress = [a, b, c, d, e, f]

                    // index2kombo
                    this.enumKombo = { '0':'a', '1':'b', '2':'c', '3':'d', '4':'e', '5':'f' }
                    // kombo2uid
                    this.enumUspechy = { 'a':32, 'b':36, 'c':25, 'd':2, 'e':6, 'f':34 }
                }

                // skontroluj či je použitý produkt súčasť komba
                for (var i = 0; i < this.achievementProgress.length; i++) {
                    if (typeof(this.achievementProgress[i][produkt_id.toString()]) != 'undefined') {
                        //console.log('produkt je súčasť komba: ' + i)
                        this.achievementProgress[i][produkt_id.toString()] = parseInt(this.achievementProgress[i][produkt_id.toString()]) + 1
                    }
                }

                // skontroluj či je dáke kombo hotové
                var indexKomba = -1
                for (var i = 0; i < this.achievementProgress.length; i++) {
                    var counter = 0
                    for (var prop in this.achievementProgress[i]) {
                        if (this.achievementProgress[i][prop] == 1) {
                            counter++
                        }
                    }
                    //console.log('counter: ' + counter)
                    if (counter == 3) {
                        indexKomba = i
                    }
                }

                // vyber kombo podľa indexu
                if (indexKomba >= 0) {
                    var dokonceneKombo = this.enumKombo[indexKomba.toString()]
                    var uid = this.enumUspechy[dokonceneKombo]
                    if (typeof(uid) != 'undefined') { this.achievements(uid) }

                } else {
                    this.isDisabled[0] = false
                    this.isDisabled[1] = false
                }
            },

            achievements(uid) {
                var key = EventService.checkAchievementProgress(this.profil, uid)
                if (key > -2) {
                    EventService.setAchievementProgress(this.profil, uid)
                        .then(response => {
                            //console.log(response.data)
                            //this.responseType = response.data.code
                            //this.responseText = response.data.data

                            sessionStorage.removeItem("login")
                            sessionStorage.setItem("album-uspechy", "refresh")

                            if (key == -1) {
                                this.$emit('updateProfil')
                            } else {
                                this.profil.pouzivatel_id.album_pouzivatela[key].repozitar_albumu_current += 1
                                this.$emit('update:profil', this.profil)
                            }

                            // achievements toast popup
                            this.$toast.success(' ', response.data.data)

                            this.isDisabled[1] = false
                        })
                        .catch(error => {
                            this.responseType = 'warning'
                            this.responseText = error
                        })
                }
            },
        }
    }
</script>